(() => {
  const header = document.querySelector('[data-global-header]');
  const updateHeaderState = () => document.body.classList.toggle('utz-header-scrolled', window.scrollY > 6);
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  document.querySelectorAll('.header__dropdown').forEach((dropdown) => {
    let closeTimer;
    const desktopHover = () => window.matchMedia('(min-width: 901px) and (hover: hover)').matches;
    dropdown.addEventListener('mouseenter', () => {
      if (!desktopHover()) return;
      window.clearTimeout(closeTimer);
      dropdown.setAttribute('open', '');
    });
    dropdown.addEventListener('mouseleave', () => {
      if (!desktopHover()) return;
      closeTimer = window.setTimeout(() => dropdown.removeAttribute('open'), 140);
    });
    dropdown.addEventListener('focusout', (event) => {
      if (desktopHover() && !dropdown.contains(event.relatedTarget)) dropdown.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-clean-product-description]').forEach((description) => {
    const blocked = new Set([
      'levertijd circa 14 dagen',
      'verzending in nederland en belgië',
      '14 dagen bedenktijd'
    ]);
    description.querySelectorAll('p, li').forEach((element) => {
      const text = element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text || blocked.has(text)) element.remove();
    });
    description.querySelectorAll('div, section, ul, ol').forEach((element) => {
      if (!element.textContent.trim() && !element.querySelector('video, table, details')) element.remove();
    });
    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest('style, script')) continue;
      node.nodeValue = node.nodeValue.replace(/14 dagen bedenktijd/gi, '30 dagen bedenktijd');
    }
    const meaningfulCopy = description.cloneNode(true);
    meaningfulCopy.querySelectorAll('style, script, img, picture, figure, .utz-badge').forEach((element) => element.remove());
    if (!meaningfulCopy.textContent.trim() && !meaningfulCopy.querySelector('video, table, details')) description.remove();
  });

  if (header) {
    const headerSection = header.closest('.shopify-section');
    if (headerSection) headerSection.classList.add('utz-sticky-header');
  }
})();
